export const testimonials = [
  {
    quote:
      'ALEgION shifted our conversation from policies to resilience. We now see protection as an architecture—and that changed how the board decides.',
    name: 'Chief Risk Officer',
    title: 'Manufacturing Conglomerate',
  },
  {
    quote:
      'What stood out was the discipline of AERA™. Anticipate, assess, architect, activate, advance—it gave us a language and a method our leadership could own.',
    name: 'COO',
    title: 'Healthcare Network',
  },
  {
    quote:
      'They treat insurance as one layer inside a broader strategy. That is exactly how serious organizations should think about continuity and confidence.',
    name: 'CFO',
    title: 'Technology Enterprise',
  },
];
